document.addEventListener("DOMContentLoaded", function () {
  const setComparisonCounter = (count) => {
    const value = parseInt(count);
    const comparisonCounterEl = document.querySelector(".js-comparison-counter");
    if (!isNaN(value) && comparisonCounterEl) {
      comparisonCounterEl.innerHTML = value > 0 ? (value > 99 ? "99+" : value) : "";
    }
  };

  // Сброс категории
  const comparisonClearCategoryEl = document.querySelectorAll(".js-compare-clear-category");
  if (comparisonClearCategoryEl) {
    comparisonClearCategoryEl.forEach(el => el.addEventListener("click", async function () {
      const category_id = Number(this.dataset.category);

      if (!isNaN(category_id)) {
        const body = new FormData();
        body.append("category_id", category_id);

        try {
          const response = await fetch("/comparison/ajax/clear_category", {
            method: "POST",
            body,
          });
          const data = await response.text();
          setComparisonCounter(data);
          location.reload();
        } catch (e) {
          console.error(e);
        }
      }
    }));
  }

  // Скрытие одинаковых характеристик
  const comparisonHideSameEl = document.querySelectorAll(".js-compare-hide-same");
  if (comparisonHideSameEl) {
    comparisonHideSameEl.forEach(el => el.addEventListener("click", function () {
      const btn = this;
      if (btn.dataset.hidden === "true") {
        btn.closest("section")
          .querySelectorAll(".js-compare-property")
          .forEach(function (propertyEl) {
            propertyEl.classList.remove("d-none");
            btn.textContent = btn.dataset.hideText;
            btn.dataset.hidden = "false";
          });
      } else {
        btn.closest("section")
          .querySelectorAll(".js-compare-property")
          .forEach(function (propertyEl) {
            const values = [].slice.call(propertyEl.querySelectorAll(".js-compare-property-value"))
              .map(function (valueEl) {
                return valueEl.dataset.propertyValue;
              });
            const equal = new Set(values).size == 1;

            if (values && values.length && equal) {
              propertyEl.classList.add("d-none");
              btn.textContent = btn.dataset.showText;
              btn.dataset.hidden = "true";
            }
          });
      }
    }));
  }

  // Переключение товара влево
  const comparisonPrevProductEl = document.querySelectorAll(".js-compare-prev-product");
  if (comparisonPrevProductEl) {
    comparisonPrevProductEl.forEach(el => el.addEventListener("click", function (e) {
      const position = this.dataset.productColumn;
      const current = Number(this.closest(".dh-compare__table__product-info").dataset.productIndex);

      if (!isNaN(current) && current > 1) {
        this.closest(".dh-compare__table__product-info").classList.remove("d-flex");
        this.closest(".dh-compare__table__product-info").classList.add("d-none");
        this.closest(".dh-compare__table__product-info")
          .previousElementSibling
          .classList.remove("d-none");
        this.closest(".dh-compare__table__product-info")
          .previousElementSibling
          .classList.add("d-flex");

        this.closest(".js-compare-products")
          .querySelectorAll(".js-compare-product-" + position + " .js-compare-property-value")
          .forEach(function (valueEl) {
            if (Number(valueEl.dataset.productIndex) === (current - 1)) {
              valueEl.classList.remove("d-none");
            } else {
              valueEl.classList.add("d-none");
            }
          });
      }
    }));
  }

  // Переключение товара вправо
  const comparisonNextProductEl = document.querySelectorAll(".js-compare-next-product");
  if (comparisonNextProductEl) {
    comparisonNextProductEl.forEach(el => el.addEventListener("click", function (e) {
      const position = this.dataset.productColumn;
      const total = Number(this.closest(".js-compare-products").dataset.productsTotal);
      const current = Number(this.closest(".dh-compare__table__product-info").dataset.productIndex);

      if (!isNaN(current) && !isNaN(total) && current < total) {
        this.closest(".dh-compare__table__product-info")
          .classList.remove("d-flex");
        this.closest(".dh-compare__table__product-info").classList.add("d-none");
        this.closest(".dh-compare__table__product-info")
          .nextElementSibling
          .classList.remove("d-none");
        this.closest(".dh-compare__table__product-info")
          .nextElementSibling
          .classList.add("d-flex");

        this.closest(".js-compare-products")
          .querySelectorAll(".js-compare-product-" + position + " .js-compare-property-value")
          .forEach(function (valueEl) {
            if (Number(valueEl.dataset.productIndex) === (current + 1)) {
              valueEl.classList.remove("d-none");
            } else {
              valueEl.classList.add("d-none");
            }
          });
      }
    }));
  }
});